import createBreadcrumbsSchema from "./createBreadcrumbsSchema";

export default createBreadcrumbsSchema;
